interface AdmissionPlaceholderDragStartProps {
  height?: number;
}

export const AdmissionPlaceholderDragStart = ({ height = 100 }: AdmissionPlaceholderDragStartProps) => {
  return (
    <div
      className='bg-secondary border border-dashed border-soft rounded-lg w-full'
      style={{ height: `${height}px` }}
    />
  );
};
